import styled from 'styled-components';
// import TwitterIcon from '@mui/icons-material/Twitter';
import XIcon from '@mui/icons-material/X';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import { WhatsApp } from '@mui/icons-material';
import { Bio, Slogan, CopyrightText } from '../../data/constants';

const FooterContainer = styled.div`
  width: 100%;
  padding: 2rem 0;
  display: flex;
  justify-content: center;
  //background: linear-gradient(100.26deg, rgba(0, 102, 255, 0.05) 42.33%, rgba(150, 0, 225, 0.05) 127.07%);
`;


const FooterWrapper = styled.footer`
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  align-items: center;
  padding: 1rem;
  color: ${({ theme }) => theme.text_primary};
`;

const Logo = styled.h4`
  font-weight: 400;
  font-style: italic;
  color: ${({ theme }) => theme.primary};
  user-select: none;
`;

const Nav = styled.nav`
  width: 100%;
  max-width: 800px;
  margin-top: 0.5rem;
  display: flex;
  flex-direction: row;
  gap: 2rem;
  justify-content: center;
  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: center;
    text-align: center;
    font-size: 12px;
  }
`;

const NavLink = styled.a`
color: ${({ theme }) => theme.text_primary};
  text-decoration: none;
  font-size: 1.2rem;
  transition: color 0.2s ease-in-out;
  &:hover {
    color: ${({ theme }) => theme.primary};
  }
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const SocialMediaIcons = styled.div`
  display: flex;
  margin-top: 1rem;
`;

const SocialMediaIcon = styled.a`
  display: inline-block;
  margin: 0 1rem;
  font-size: 1.5rem;
  color: ${({ theme }) => theme.text_primary};
  transition: color 0.2s ease-in-out;
  &:hover {
    color: ${({ theme }) => theme.primary};
  }
`;

const Copyright = styled.p`
  margin-top: 1.5rem;
  font-size: 0.9rem;
  color: ${({ theme }) => theme.soft2};
  text-align: center;
`;

function Footer() {
  return (
    <FooterContainer>
      <FooterWrapper>
        <Logo>{Slogan}</Logo>
        <Nav>
          <NavLink href="#about-me"
            onClick={() =>
              setTimeout(() => {
                const contactUsSection = document.getElementById('about-me');
                if (contactUsSection) {
                  const componentHeight = 100;
                  const scrollOffset = contactUsSection.offsetTop - componentHeight;
                  window.scrollTo({ top: scrollOffset, behavior: 'smooth' });
                }
              }, 0)}>
            About
          </NavLink>
          <NavLink href='#skills-details'
            onClick={() =>
              setTimeout(() => {
                const contactUsSection = document.getElementById('skills-details');
                if (contactUsSection) {
                  const componentHeight = 80;
                  const scrollOffset = contactUsSection.offsetTop - componentHeight;
                  window.scrollTo({ top: scrollOffset, behavior: 'smooth' });
                }
              }, 0)}>
            Skills
          </NavLink>
          <NavLink href='#experience-details'
            onClick={() =>
              setTimeout(() => {
                const contactUsSection = document.getElementById('experience-details');
                if (contactUsSection) {
                  const componentHeight = -50;
                  const scrollOffset = contactUsSection.offsetTop - componentHeight;
                  window.scrollTo({ top: scrollOffset, behavior: 'smooth' });
                }
              }, 0)}>
            Experience
          </NavLink>
          <NavLink href='#projects-details'
            onClick={() =>
              setTimeout(() => {
                const contactUsSection = document.getElementById('projects-details');
                if (contactUsSection) {
                  const componentHeight = 70;
                  const scrollOffset = contactUsSection.offsetTop - componentHeight;
                  window.scrollTo({ top: scrollOffset, behavior: 'smooth' });
                }
              }, 0)}>
            Projects
          </NavLink>
          <NavLink href='#education-details'
            onClick={() =>
              setTimeout(() => {
                const contactUsSection = document.getElementById('education-details');
                if (contactUsSection) {
                  const componentHeight = 30;
                  const scrollOffset = contactUsSection.offsetTop - componentHeight;
                  window.scrollTo({ top: scrollOffset, behavior: 'smooth' });
                }
              }, 0)}>
            Education
          </NavLink>
          <NavLink href='#contact-me'
            onClick={() =>
              setTimeout(() => {
                const contactUsSection = document.getElementById('contact-me');
                if (contactUsSection) {
                  const componentHeight = 60;
                  const scrollOffset = contactUsSection.offsetTop - componentHeight;
                  window.scrollTo({ top: scrollOffset, behavior: 'smooth' });
                }
              }, 0)}>
            Contact
          </NavLink>
        </Nav>
        <SocialMediaIcons>
          <SocialMediaIcon href={Bio.twitter} target="display"><XIcon /></SocialMediaIcon>
          <SocialMediaIcon href={Bio.linkedin} target="display"><LinkedInIcon /></SocialMediaIcon>
          <SocialMediaIcon href={Bio.insta} target="display"><InstagramIcon /></SocialMediaIcon>
          <SocialMediaIcon href={Bio.whatsapp} target="display"><WhatsApp /></SocialMediaIcon>
        </SocialMediaIcons>
        <Copyright>
          {CopyrightText}
        </Copyright>

      </FooterWrapper>
    </FooterContainer>
  );
}

export default Footer;